import { render, staticRenderFns } from "./Wp_tb_order_page.vue?vue&type=template&id=75e912e4&scoped=true&"
import script from "./Wp_tb_order_page.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_order_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e912e4",
  null
  
)

export default component.exports